import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import ResponsiveTable from '../components/ResponsiveTable'
import Pagination from '../components/Pagination'

const RechargeHistory = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [page, setPage] = useState(1)
    const [pageCount, setPageCount] = useState(0)
    const [resultQty, setResultQty] = useState(25)
    const [results, setResults] = useState([])
    const [paginatedResults, setPaginatedResults] = useState([])

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        resetTransactions()
    }, [page])

    const getData = () => {
        DataSource.getData(`/api/getRechargeHistory/${props.serviceId}`, response => {
            setResults(response.data)
            setPaginatedResults(paginateResults(response.data))
            setPageNumber(response.data)
            setIsLoaded(true)
        }, () => {
            setIsLoaded(true)
            setHasError(true)
        })
    }

    const paginateResults = results => {
        const start = (page - 1) * resultQty
        const end = start + resultQty

        return results.slice(start, end)
    }

    const setPageNumber = results => {
        setPageCount(Math.max(1, Math.ceil(results.length / resultQty)))
    }

    const handlePageChange = event => {
        event.preventDefault()
        const page = event.target.dataset.page
        setIsLoaded(false)
        setTimeout(() => {
            setPage(parseInt(page))
            setIsLoaded(true)
        }, 200)
    }

    const resetTransactions = () => {
        setPaginatedResults(paginateResults(results))
        setPageNumber(results)
    }

    const transactionData = {
        headings: ['Purchase date', 'Expiry date', 'Description', 'Amount'],
        rows: paginatedResults
    }

    return (
        <div className='recharge-history module'>
            <Heading title='Recharge & Add-on history' />
            <ModuleWithLoader isLoaded={isLoaded} hasError={hasError} className='p-4'>
                <div className='row'>
                    <div className='col-12'>
                        {paginatedResults.length > 0
                            ? <ResponsiveTable data={transactionData} minWidthMobile={600} />
                            : <div className='row-error text-center mt-3'>No history to display yet</div>}
                    </div>
                </div>
                <Pagination page={page} pageCount={pageCount} handleClick={handlePageChange} />
            </ModuleWithLoader>
        </div>
    )
}

RechargeHistory.propTypes = {
    serviceId: PropTypes.number.isRequired
}

export default RechargeHistory



// WEBPACK FOOTER //
// ./resources/js/modules/RechargeHistory.js